/********************************************************************************
 * Copyright (c) 2023 Business Informatics Group (TU Wien) and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

.accessibility-tool-palette .header-tools i {
    position: relative;
}

.accessibility-tool-palette .tool-button .key-shortcut,
.accessibility-tool-palette .header-tools .key-shortcut {
    display: none;
    position: absolute;

    border-radius: 50%;
    width: 0.5rem;
    height: 0.5rem;
    padding: 0.5rem;

    background: #fff;
    border: 2px solid #666;
    color: black;
    text-align: center;

    font:
        bold 0.8rem Arial,
        sans-serif;
    line-height: 0.5rem;
}

.accessibility-tool-palette .tool-button .key-shortcut {
    left: -2rem;
}

.accessibility-tool-palette .header-tools .key-shortcut {
    top: -2.5rem;
    right: -0.3rem;
}

.accessibility-show-shortcuts:focus-within .header-tools .key-shortcut,
.accessibility-show-shortcuts:focus-within .tool-button .key-shortcut {
    display: block;
}

.accessibility-tool-palette.collapsible-palette {
    overflow: visible;
}

.accessibility-tool-palette.collapsible-palette + .minimize-palette-button {
    top: 50px;
}
